export default __webpack_public_path__ + "static/media/Mercenary's Belt of Grinning Skulls.1b249827.jpg";